import type { ModuleManifest } from "./types";

export const antiMoneyLaunderingManifest: ModuleManifest = {
  name: "anti-money-laundering",
  label: "Antiriciclaggio",
  labelPlural: "Antiriciclaggio",
  coreBOSModule: "evAntiMoneyLaundering",
  wsidPrefix: "84x",
  type: "standard",
  routes: {
    list: "/anti-money-laundering",
    show: "/anti-money-laundering/show/:id",
    create: "/anti-money-laundering/create",
    edit: "/anti-money-laundering/edit/:id",
  },
  navigation: {
    icon: "ReconciliationOutlined",
    order: 1,
    group: "Compliance",
    hidden: false,
  },
  routing: {
    keywords: ["antiriciclaggio", "aml", "anti-money-laundering", "riciclaggio", "fascicolo"],
    searchFields: ["subject", "fascicolo_numero"],
    defaultSort: { field: "subject", order: "asc" },
  },
  context: { supported: false, entityKey: "anti-money-laundering" },
  fields: [
    { name: "subject", label: "Soggetto", type: "string", required: true },
    { name: "fascicolo_numero", label: "Numero Fascicolo", type: "string" },
    { name: "tipo_verifica", label: "Tipo Verifica", type: "picklist" },
    { name: "livello_rischio", label: "Livello Rischio", type: "picklist" },
    { name: "data_verifica", label: "Data Verifica", type: "date" },
    { name: "data_valutazione_rischio", label: "Data Valutazione Rischio", type: "date" },
    { name: "scadenza_prossima_verifica", label: "Scadenza Prossima Verifica", type: "date" },
    { name: "stato_conservazione", label: "Stato Conservazione", type: "picklist" },
    { name: "data_inizio_conservazione", label: "Data Inizio Conservazione", type: "date" },
    { name: "data_fine_conservazione", label: "Scadenza Conservazione (10 anni)", type: "date" },
    { name: "sos_effettuata", label: "Segnalazione SOS", type: "picklist" },
    { name: "data_segnalazione_sos", label: "Data Segnalazione SOS", type: "date" },
    { name: "numero_protocollo_sos", label: "Numero Protocollo SOS", type: "string" },
    { name: "fattori_rischio", label: "Fattori di Rischio", type: "text" },
    { name: "modulo_av1", label: "Modulo AV.1 (Valutazione Rischio)", type: "string" },
    { name: "modulo_av3", label: "Modulo AV.3 (Istruttoria Cliente)", type: "string" },
    { name: "modulo_av4", label: "Modulo AV.4 (Dichiarazione Cliente)", type: "string" },
    { name: "cliente_riferimento", label: "Cliente", type: "reference" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    {
      module: "Accounts",
      field: "cliente_riferimento",
      relation: "one-to-many",
      label: "Cliente",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documenti",
      icon: "FolderOutlined",
      displayField: "notes_title",
    },
  ],
  requiredFields: ["subject"],
  viewStrategy: "bespoke",
};
